<!--Author: Michał Pawłowski-->
<template>
  <header v-if="title != undefined && title != null && title.length > 0">
    {{ title }}
  </header>

  <div class="" style="padding: 0">
    <div class="row">
      <div class="input-group mb-2 list-card">
        <div class="col col-lg-3 key-value-form-col">
          <input
            v-on:keydown.enter="addElement()"
            v-model="elementToAdd.name"
            type="text"
            :class="elementInputClass"
            :placeholder="elementInputPlaceholder"
            aria-describedby="mutable-lisview-element-input-name-feedback"
            style="height: 33px"
          />
          <div
            class="invalid-feedback"
            id="mutable-lisview-element-input-name-feedback"
          >
            Ten element jest już na liście
          </div>
        </div>
        <div class="col col-lg-3 key-value-form-col">
          <select
            v-model="elementToAdd.type"
            @input="elementToAdd.type = $event.target.value"
            style="height: 33px"
          >
            <option
              v-for="(value, index) in [
                'STRING',
                'INTEGER',
                'DOUBLE',
                'BOOLEAN',
                'DATE',
                'TIME',
                'DATETIME',
              ]"
              :selected="elementToAdd.type === value"
              :key="index"
              :value="value"
            >
              {{ value }}
            </option>
          </select>
        </div>

        <div class="col col-lg-3 key-value-form-col">
          <div
            v-if="
              elementToAdd.type === 'INTEGER' || elementToAdd.type === 'LONG'
            "
          >
            <input
              v-model="elementToAdd.value"
              type="number"
              :class="elementInputClass"
              :aria-describedby="feedbackElementId"
              min="0"
              step="1"
              placeholder="0"
              :style="inputStyle"
            />
            <div class="invalid-feedback" :id="feedbackElementId">
              {{ invalidInputMessage }}
            </div>
          </div>
          <div v-else-if="elementToAdd.type === 'DOUBLE'">
            <input
              v-model="elementToAdd.value"
              type="number"
              :class="elementInputClass"
              :aria-describedby="feedbackElementId"
              min="0.00"
              step="0.01"
              placeholder="0.00"
              :style="inputStyle"
            />
            <div class="invalid-feedback" :id="feedbackElementId">
              {{ invalidInputMessage }}
            </div>
          </div>
          <div v-else-if="elementToAdd.type === 'BOOLEAN'">
            <select
              v-model="elementToAdd.value"
              :class="elementInputClass"
              :aria-describedby="feedbackElementId"
              :style="inputStyle"
            >
              <option value="" disabled selected hidden>Wybierz</option>
              <option value="true">Tak</option>
              <option value="false">Nie</option>
            </select>
            <div class="invalid-feedback" :id="feedbackElementId">
              {{ invalidInputMessage }}
            </div>
          </div>
          <div v-else-if="elementToAdd.type === 'DATE'">
            <input
              v-model="elementToAdd.value"
              type="date"
              :class="elementInputClass"
              :aria-describedby="feedbackElementId"
              :style="inputStyle"
              placeholder="yyyy-mm-dd"
            />
            <div class="invalid-feedback" :id="feedbackElementId">
              {{ invalidInputMessage }}
            </div>
          </div>

          <div v-else-if="elementToAdd.type === 'TIME'">
            <input
              v-model="elementToAdd.value"
              type="time"
              :class="elementInputClass"
              :aria-describedby="feedbackElementId"
              :style="inputStyle"
              placeholder="hh:mm:ss"
            />
            <div class="invalid-feedback" :id="feedbackElementId">
              {{ invalidInputMessage }}
            </div>
          </div>
          <div v-else-if="elementToAdd.type === 'DATETIME'">
            <input
              v-model="elementToAdd.value"
              type="datetime-local"
              :class="elementInputClass"
              :aria-describedby="feedbackElementId"
              :style="inputStyle"
              placeholder="yyyy-mm-dd hh:mm:ss"
            />
            <div class="invalid-feedback" :id="feedbackElementId">
              {{ invalidInputMessage }}
            </div>
          </div>
          <div v-else>
            <input
              v-model="elementToAdd.value"
              type="text"
              :class="elementInputClass"
              :aria-describedby="feedbackElementId"
              placeholder="wpisz wartość..."
              :style="inputStyle"
            />
            <div class="invalid-feedback" :id="feedbackElementId">
              {{ invalidInputMessage }}
            </div>
          </div>
        </div>

        <div class="input-box">
          <div @click="addElement()" style="color: green; font-size: 1.5em">
            <i>
              <i class="fas fa-plus-circle" />
            </i>
          </div>
        </div>
      </div>
      <div class="row">
        <nav>
          <ol class="list-group internal-placement" :style="ulStyle">
            <li
              v-for="li in list"
              :key="li"
              class="list-group-item d-flex justify-content-between align-items-start"
            >
              <div class="ms-2 me-auto">
                <div class="fw-bold">{{ li }}</div>
              </div>
              <span
                @click="removeElement(li)"
                class="badge bg-danger rounded-pill"
                ><i class="fas fa-trash-alt"
              /></span>
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
</template>
<script>
// import { library } from "@fortawesome/fontawesome-svg-core";
// import { faPlusCircle, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
//
// library.add(faTrashAlt);
// library.add(faPlusCircle);
import {log} from "@/state/pinia/log";

export default {
  name: "MutableScrollableKeyValueTypedListView",
  // components: { FontAwesomeIcon },
  props: {
    title: String,
    listContent: Array,

    ulStyle: { type: String, default: "" },
    elementInputPlaceholder: String,
  },
  emits: ["onAddElement", "onRemoveElement"],
  data() {
    return {
      list: [],
      elementToAdd: {
        name: "",
        value: "",
        type: "",
      },
      value: "",
      feedbackElementId: "key-value-typed-input-feedback",
      valueType: "STRING", // ONE OF AVAILABLE TYPES: STRING, INTEGER, DOUBLE, BOOLEAN, DATE, TIME, DATETIME
      elementInputClass: "form-control",
      invalidInputMessage: "Wartość jest wymagana",
      inputStyle: "height: 33px",
    };
  },
  methods: {
    addElement() {
      log.log("addElement: " + this.elementToAdd.name + " " + this.value);

      var isValid = this.checkForm();
      if (
        isValid &&
        this.elementToAdd.name.length > 0 &&
        this.elementToAdd.value.length > 0 &&
        this.elementToAdd.type.length > 0
      ) {
        this.list.push(Object.assign({}, this.elementToAdd));
        this.$emit("onAddElement", this.elementToAdd);
      }
    },
    removeElement(element) {
      this.list = this.list.filter((elem) => {
        return elem.name != element.name;
      });
      if (this.list == undefined || this.list == null) {
        this.list = [];
      }
      this.$emit("onRemoveElement", element);
    },
    checkForm() {
      var isValid = true;
      var notValidFieldsCount = 0;

      if (
        this.elementToAdd.name == null ||
        this.elementToAdd.name == undefined
      ) {
        this.elementToAdd.name = "";
      }

      if (
        this.elementToAdd.value == null ||
        this.elementToAdd.value == undefined
      ) {
        this.elementToAdd.value = "";
      }

      if (
        this.elementToAdd.type == null ||
        this.elementToAdd.type == undefined
      ) {
        this.elementToAdd.type = "";
      }

      var elementAlreadyOnList = this.list.find(
        (elem) => elem.name === this.elementToAdd.name
      );

      if (elementAlreadyOnList != null && elementAlreadyOnList != undefined) {
        this.elementInputClass = "form-control is-invalid";
        notValidFieldsCount++;
      } else {
        this.elementInputClass = "form-control";
      }

      if (notValidFieldsCount > 0) {
        isValid = false;
      } else {
        isValid = true;
      }

      return isValid;
    },
  },
  watch: {
    elementToAdd: {
      handler(newVal) {
        if (newVal in this.list) {
          this.elementInputClass = "form-control is-invalid";
        }
      },
      deep: true,
    },
  },
  created() {
    this.list = JSON.parse(JSON.stringify(this.listContent));
    log.log("List modified: ");
    log.log(this.list);
  },
};
</script>
<style scoped>
nav ul {
  height: 200px;
  width: 100%;
}

nav ul {
  overflow: hidden;
  overflow-y: scroll;
}

.internal-placement {
  padding: 15px;
}

.list-card {
  padding: 0;
  border-bottom: 1px solid #c8cdd1;
  margin-bottom: 16px;
  background-color: #f5f5dc52;
  padding-top: 16px;
}

.key-value-form-col {
  margin-left: 16px;
  margin-right: 16px;
}

.add-item-btn {
  background: green;
  font-size: 1.5em;
}
</style>
